module.exports = __webpack_public_path__ + "img/triangle-90.4beb7d1c.gif";